import React from 'react';
import Chip from '@material-ui/core/Chip';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import Hidden from '@material-ui/core/Hidden';
import useDataSourceContext from '../DataSource/useDataSourceContext';
import Icon from '../Icon';
import styled from 'styled-components';

const DataGridViewsContainer = styled.div`
  padding: 0 ${props => props.theme.spacing()}px;
`;

const NewViewButton = styled(IconButton)`
  && {
    border: 1px solid ${props => props.theme.palette.primary.main};

    .MuiSvgIcon-root {
      color: ${props => props.theme.palette.primary.main};
    }
  }
`;

const DataGridViews = () => {
  const {
    views: viewsModule = {},
    setShowViewsSelection,
    setShowSaveViewSelection,
  } = useDataSourceContext();
  const { fixedViews = [], getAvailableViews, getActiveView, setActiveView } = viewsModule;
  const activeView = getActiveView();
  const availableViews = getAvailableViews();
  const visibleViews = [...fixedViews, ...(availableViews ?? [])];

  const handleViewClick = key => {
    if (activeView?.key === key) {
      setActiveView(null);
      return;
    }

    setActiveView(key);
  };

  return (
    <DataGridViewsContainer>
      <Box display="flex" alignItems="center" mx={-0.5} style={{ overflow: 'auto' }}>
        <Box p={0.5}>
          <IconButton variant="outlined" size="small" onClick={() => setShowViewsSelection(true)}>
            <Icon icon={['fal', 'eye']} size="small" />
          </IconButton>
        </Box>
        {visibleViews.slice(0, 10).map(view => {
          let displayVariant = 'outlined';

          if (visibleViews.length === 0) {
            displayVariant = 'outlined';
          }

          if (visibleViews.length > 0 && view?.key === activeView?.key) {
            displayVariant = 'default';
          }

          return (
            <Box p={0.5} key={view?.key ?? view}>
              <Chip
                label={view?.name}
                color="primary"
                variant={displayVariant}
                onClick={() => handleViewClick(view.key)}
              />
            </Box>
          );
        })}
        <Hidden smDown>
          <Box p={0.5}>
            <NewViewButton size="small" onClick={() => setShowSaveViewSelection(true)}>
              <Icon icon={['fal', 'plus']} size="small" />
            </NewViewButton>
          </Box>
        </Hidden>
      </Box>
    </DataGridViewsContainer>
  );
};

export default DataGridViews;
